module.exports = __webpack_public_path__ + "static/media/evom_white_logo.e7c858d8.png";